import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import { authenticationGuard, homeGuard, multiGuard } from '../auth/authenticationGuard';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    beforeEnter: homeGuard,
  },
  {
    path: '/student/requests',
    name: 'StudentRequests',
    component: () => import(/* webpackChunkName: "student" */ '../views/StudentRequests.vue'),
    meta: { requiresAuth: true },
    beforeEnter: multiGuard,
  },
  // {
  //   path: '/student/new-request',
  //   name: 'StudentNewRequest',
  //   component: () => import(/* webpackChunkName: "student" */ '../views/StudentNewRequest.vue'),
  //   meta: { requiresAuth: true },
  //   beforeEnter: multiGuard,
  // },
  {
    path: '/student/requests/:requestId',
    name: 'StudentRequestDetails',
    component: () => import(/* webpackChunkName: "student" */ '../views/StudentRequestDetails.vue'),
    meta: { requiresAuth: true },
    props: true,
    beforeEnter: multiGuard,
  },
  {
    path: '/partners',
    name: 'Partners',
    component: () => import(/* webpackChunkName: "partners" */ '../views/Partners.vue'),
    meta: { requiresAuth: true },
    beforeEnter: multiGuard,
  },
  {
    path: '/companies',
    name: 'Companies',
    component: () => import(/* webpackChunkName: "companies" */ '../views/Companies.vue'),
    meta: { requiresAuth: true },
    beforeEnter: multiGuard,
  },
  {
    path: '/statistics',
    name: 'Statistics',
    component: () => import(/* webpackChunkName: "statistics" */ '../views/Statistics.vue'),
    meta: { requiresAuth: true },
    beforeEnter: multiGuard,
  },
  {
    path: '/teachers',
    name: 'Teachers',
    component: () => import(/* webpackChunkName: "teachers" */ '../views/Teachers.vue'),
    meta: { requiresAuth: true },
    beforeEnter: multiGuard,
  },
  {
    path: '/requests',
    component: () => import(/* webpackChunkName: "requests" */ '../views/Requests.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'RequestList',
        component: () => import(/* webpackChunkName: "requests" */ '../components/requests/RequestList.vue'),
        beforeEnter: multiGuard,
      },
      {
        path: ':id',
        name: 'RequestDetails',
        component: () => import(/* webpackChunkName: "requests" */ '../components/requests/RequestDetails.vue'),
        props: true,
        beforeEnter: multiGuard,
      },
    ],
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(authenticationGuard);

export default router;
